import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-warning',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-warning.component.html',
  styleUrl: './alert-warning.component.scss'
})
export class AlertWarningComponent {
  isDisabled: boolean = false;
  @Input() Message: string = '';
  @Input() Message2: string = '';
  @Input() showOk: boolean = true;
  
  constructor(
    private activeModal: NgbActiveModal,
  ) {}

  close(result:boolean) {
    this.activeModal.close(result);
  }
}
